import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-loga-firm',
  templateUrl: './loga-firm.component.html',
  styleUrls: ['./loga-firm.component.scss']
})
export class LogaFirmComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
